module.exports = __webpack_public_path__ + "static/media/WP_20170507_003.49ca021c.jpg";